var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProjectorAnalyticsIcon = function SvgProjectorAnalyticsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 244 244"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(16 12)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 10,
    d: "M207 5v130a26.92 26.92 0 0 1-7.908 19.092A26.92 26.92 0 0 1 180 162H32a26.92 26.92 0 0 1-19.092-7.908A26.92 26.92 0 0 1 5 135V5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 32,
    d: "M0 5h212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M125.054 160.88h32.32l18.5 32.043c3.867 6.696 1.572 15.259-5.124 19.125l.001.001c-6.696 3.866-15.258 1.572-19.124-5.124l-.001-.002zM86.867 160.88H54.546l-18.5 32.043c-3.866 6.697-1.572 15.259 5.124 19.125l-.001.001c6.696 3.866 15.258 1.572 19.124-5.124l.001-.002z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 121.5,
    r: 15.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.5,
    cy: 118.5,
    r: 15.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 62.5,
    r: 15.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.5,
    cy: 58.5,
    r: 15.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "m47.5 121.5 39.374-59 33.626 56 44-60"
  }))));
};
export default SvgProjectorAnalyticsIcon;